// Zone.js patches browser events so Angular can run change detection after callbacks.
// `unload`/`beforeunload` listeners are deprecated in Chromium and can trigger Lighthouse warnings.
// This app does not rely on Angular change detection from those events, so leave them unpatched.
(window as Window & { __zone_symbol__UNPATCHED_EVENTS?: string[] }).__zone_symbol__UNPATCHED_EVENTS = [
  'unload',
  'beforeunload',
];
